import React from "react";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { Icon } from "@iconify/react";
import { Avatar, Button, List, Popconfirm, Tooltip } from "antd";

import { Member, MembersListProps } from "js/pages/Organization/types";

import { useDeleteMember } from "../../../hooks/useOrganizations";

const MembersList: React.FC<MembersListProps> = ({
  list,
  initLoading,
  isOwner,
}) => {
  const deleteMemberMutation = useDeleteMember();

  const handleDelete = (member: Member) => {
    deleteMemberMutation.mutate(member.id);
    // Hook automatically shows success message and invalidates cache!
    // Parent component will automatically refetch!
  };

  return (
    <>
      <List
        loading={initLoading}
        itemLayout="horizontal"
        dataSource={list}
        renderItem={(item: Member, index) => (
          <List.Item
            actions={
              isOwner
                ? [
                    <Popconfirm
                      title="Eliminar Asesor"
                      description="¿Seguro que deseas eliminar?"
                      onConfirm={() => handleDelete(item)}
                      icon={
                        <QuestionCircleOutlined
                          style={{ color: "red" }}
                          rev={undefined}
                        />
                      }
                      okText={"Ok"}
                      cancelText={"Cancelar"}
                    >
                      <Tooltip title={"Eliminar"}>
                        <Button
                          danger
                          type={"link"}
                          loading={deleteMemberMutation.isPending}
                          icon={<Icon fontSize={20} icon="bi:trash3" />}
                        />
                      </Tooltip>
                    </Popconfirm>,
                  ]
                : []
            }
            style={{
              background: index % 2 === 1 ? "#F2F5F9FF" : "#ffffff",
            }}
          >
            <List.Item.Meta
              avatar={
                <Avatar
                  size={50}
                  style={{
                    backgroundColor: index % 2 !== 1 ? "#F2F5F9FF" : "#ffffff",
                    color: "#0f5ef7",
                    marginRight: 10,
                    marginLeft: 20,
                  }}
                >
                  {item.name?.slice(0, 1)}
                  {item.first_surname?.slice(0, 1)}
                </Avatar>
              }
              title={<span className="sentry-mask">{`${item?.name} ${item?.first_surname}`}</span>}
              description={item?.role == "Owner" ? "Administrador" : "Asesor"}
            />
            <List.Item.Meta title={<span className="sentry-mask">{item.email}</span>} />
          </List.Item>
        )}
      />
    </>
  );
};

export default MembersList;
